
import CopySuccess from "../../../assets/filled/CopySuccess.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CopySuccessIcon({ className, dataTestid = "CopySuccessIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CopySuccess data-testid={dataTestid} className={classes} {...rest} />
  );
}
